const variants = {
	solid: 'button--solid',
	outline: 'button--outline',
	danger: 'button--danger',
};

interface ButtonParams {
	children: React.ReactNode;
	variant?: keyof typeof variants;
	onClick?: VoidFunction;
	style?: React.CSSProperties;
	disabled?: boolean;
	iconLeftSrc?: string;
	iconRightSrc?: string;
}

export const Button = ({ children, variant = 'solid', iconLeftSrc, iconRightSrc, ...props }: ButtonParams) => {
	return (
		<button className={`button ${variants[variant]}`} {...props}>
			{iconLeftSrc && <img src={iconLeftSrc} alt="" />}
			{children}
			{iconRightSrc && <img src={iconRightSrc} alt="" />}
		</button>
	);
};
